export enum ConnectionState {
    Connecting,
    Connected,
    ConnectionLost
}

export enum RequestState {
    Searching,
    Writing,
    Done
}

export enum Sender {
    User,
    AI,
    Error
}

export type Message = {
    sender: Sender,
    text: string
}
export type Source = {
    uid: string,
    url_id: string,
    title: string
}

export enum FeedbackType {
    None,
    Like,
    Dislike,
}

export type Feedback = {
    type: FeedbackType,
    sessionId: string,
    chatHistory?: Message[],
    feedbackMessage?: string,
    searchQuality?: number,
    answerQuality?: number
}

export type Scope = {
    id: string,
    title: string,
    default: boolean,
    level?: number
}

export type Scopes = Scope[]

export function isScope(obj: unknown): obj is Scope {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'id' in obj &&
        'title' in obj &&
        'default' in obj &&
        typeof obj.id === 'string' &&
        typeof obj.title === 'string' &&
        typeof obj.default === 'boolean'
    );
}

export function isScopeArray(array: unknown): array is Scope[] {
    if (!Array.isArray(array)) {
        return false;
    }
    for (const arrayElement of array) {
        if (!isScope(arrayElement)) {
            return false;
        }
    }
    return true;
}

export function isSource(obj: unknown): obj is Source {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'uid' in obj &&
        'url_id' in obj &&
        'title' in obj &&
        typeof obj.uid === 'string' &&
        typeof obj.url_id === 'string' &&
        typeof obj.title === 'string'
    );
}

export function isSourceArray(array: unknown): array is Source[] {
    if (!Array.isArray(array)) {
        return false;
    }
    for (const arrayElement of array) {
        if (!isSource(arrayElement)) {
            return false;
        }
    }
    return true;
}
